export default __webpack_public_path__ + "static/media/check_24px_outlined.670427b7.svg";